import React from "react";
import Slider from "react-slick";

import { DoctorHighlight } from "../DoctorHighlight/DoctorHighlight";
import classNames from "classnames";
import { DoctorHighlightContainerParams } from "./DoctorHighlightContainerParams.csharp";

export const DoctorHighlightContainer: React.FC<
  DoctorHighlightContainerParams
> = ({
  doctors,
  enableLargerImages,
  link,
  disableSlider,
  showAlternateColors,
}) => {
  return (
    <section
      className={classNames({
        "disable-slider": disableSlider,
        "alternate-colors": showAlternateColors,
      })}
    >
      <div className="mb-5">
        <Slider
          arrows={false}
          slidesToShow={4}
          infinite={false}
          speed={200}
          responsive={[
            {
              breakpoint: 951,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
              },
            },
          ]}
        >
          {doctors.map((d, i) => (
            <DoctorHighlight
              key={i}
              imageUrl={d.imageUrl}
              heading={d.heading}
              subheading={d.subheading}
              content={d.content}
              link={d.link}
              enableLargerImages={enableLargerImages}
              showAlternateColors={showAlternateColors}
            />
          ))}
        </Slider>
        {link.url && link.title && (
          <div className="row mt-1">
            <p className="read-more">
              <a href={link.url}>{link.title}</a>
            </p>
          </div>
        )}
      </div>
    </section>
  );
};
